import React, { useState, useEffect, useContext } from 'react';
import axios from '../../config/axios';

import AuthContext from '../../contexts/AuthContext';

import NewsItem from './NewsItem/NewsItem';
import Search from '../../components/UI/Search/Search';
import Spinner from '../../components/UI/Spinner/Spinner';

import classes from './MainPage.module.scss';

const MainPage = () => {
    const auth = useContext(AuthContext)[0];

    const [state, setState] = useState(null);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/news.json?auth=${auth.token}`)
            .then(res => {
                setState(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.log('[MAIN_PAGE AXIOS ERR] ', err.message)
            })
    }, [auth])

    let newsContent = [];
    if (state) {
        newsContent = Object.keys(state)
            .map(key => {
                return {
                    id: key,
                    data: state[key]
                }
            })
            .filter(el => el.data.active)
            .filter(el => (el.data.title.toLowerCase().includes(search.toLowerCase()) || el.data.content.toLowerCase().includes(search.toLowerCase())))
            .sort((el1, el2) => {
                const d1 = new Date(el1.data.date);
                const d2 = new Date(el2.data.date);
                return (d2.getTime() - d1.getTime());
            })
            .map(el => {
                return <NewsItem
                    key={el.id}
                    id={el.id}
                    title={el.data.title}
                    date={el.data.date}>
                    {el.data.content}
                </NewsItem>
            })
    }

    return <div className={classes.Right}>
        <div className={classes.Header}>
            <h1>Contemporary Mathematics in Kielce 2020</h1>
            <h3>MS Teams, February 24-27, 2021</h3>
        </div>
        <Search
                filter={search}
                setFilter={setSearch}
                placeholder="Search" />
        {!loading ? newsContent : <Spinner />}
    </div>
}

export default MainPage;